import { createSlice, SliceCaseReducers } from "@reduxjs/toolkit";
import { FileType, StockHoldingFileType } from "operations/schema/schema"; 
import { RootState } from "store";
import { asyncQueries, queryBuilder } from "./files.queries";

export interface State {
  files: FileType[];
  stockHoldingFiles: StockHoldingFileType[]; 
  loadingFiles: boolean;
}

interface Actions extends SliceCaseReducers<State> {}

interface Selectors {
  selectFiles: (state: RootState) => FileType[];
  selectStockHoldingFiles: (state: RootState) => StockHoldingFileType[]; 
}

export const initialState: State = {
  files: [],
  stockHoldingFiles: [], 
  loadingFiles: false,
};

const actions: Actions = {};

const selectors: Selectors = {
  selectFiles(state: RootState) {
    return state.files.files;
  },
  selectStockHoldingFiles(state: RootState) {
    return state.files.stockHoldingFiles;
  },
};

const storeBase = createSlice<State, Actions>({
  name: "files",
  initialState,
  reducers: actions,
  extraReducers: queryBuilder,
});

export default storeBase.reducer;
export const { selectFiles, selectStockHoldingFiles } = selectors;
export const { getStockHoldingFiles } = asyncQueries;